export default {
      id: "color_people-usage",
      viewBox: "0 0 57.5 62.9",
      url: __webpack_public_path__ + "sprite.svg#color_people",
      toString: function () {
        return this.url;
      }
    }